"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollBarWidth = void 0;
/**
 * A function that calculates the width of a scrollbar on an arbitrary element based on the current browser being used
 * @returns a number width value for a scrollbar
 */
const getScrollBarWidth = () => {
  const div = document.createElement("div");
  //give the div an arbitrary height and width and render it offscreen, force the scrollbar to appear
  div.style.cssText = `
                position: absolute;
                top: -100vh;
                left: -100vw;
                height: 50px;
                width: 50px;
                overflow-y: scroll;
            `;
  document.body.append(div);
  const {
    clientWidth,
    offsetWidth
  } = div;
  document.body.removeChild(div);
  return offsetWidth - clientWidth;
};
exports.getScrollBarWidth = getScrollBarWidth;
//# sourceMappingURL=getScrollbarWidth.js.map